<section style="height: auto;" translate="no">
    <nav>
      <ol class="cd-breadcrumb custom-separator">
        <table>
          <tbody>
            <tr>
              <td class="nomeTela">
                 {{nomeTela}}
              </td>
            </tr>
            <tr>
              <td>
                <li *ngFor="let bc of listabreadcrumb">
                  @if (bc.url != "") {
                    <button (click)="navigateWithStateBC(bc.url)">{{bc.label}}</button>
                  }
                  @else {
                  <em>{{bc.label}}</em>
                  }
                </li>
              </td>
            </tr>
          </tbody>
        </table>
      </ol>
    </nav>
  </section>
  <div class="div_orientacao">
  <h4 *ngIf="nomeServico" style="text-align: center;color: #999999;" translate="no">VAGAS POR SERVIÇO: {{nomeServico}}</h4>
<section class="sectionInd" translate="no">
    <div class="cards-containers">
        <div *ngFor="let ind of listaIndDiasDetalhe">
            <a class="cards-layout-CidEspera">
                <div>
                    <mat-card class="mat-card-dark" [ngStyle]="{'background-color': ind.cor.fundoCor,'width.px': 240}">
                        <div class="title-card" [ngStyle]="{'background-color': ind.cor.cabecalhoCor}">{{ind.nome}}
                        </div>
                        <div style="display: flex;">
                            <div class="Ind_icone">
                                <i [classList]="ind.icone"
                                    style="color: #ffffff;;transform: scale(1.7,1.7); --fa-secondary-opacity:0.7;"></i>
                            </div>
                            <div class="card-content">
                                <p class="pTextoInd" [innerHTML]="ind.valor"></p>
                            </div>
                        </div>
                    </mat-card>
                </div>
            </a>
        </div>
    </div>
</section>
</div>
